function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import './index.less';
var prefixCls = 'eui-error';

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      error: null,
      info: null
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        error: error,
        info: info
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          error = _this$state.error,
          info = _this$state.info;
      var _this$props = this.props,
          children = _this$props.children,
          _this$props$image = _this$props.image,
          image = _this$props$image === void 0 ? 'https://wuji-30130.sz.gfp.tencent-cloud.com/20211122_dy6n9jd88gvwrong.svg' : _this$props$image,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '出错了' : _this$props$title,
          _this$props$version = _this$props.version,
          version = _this$props$version === void 0 ? '75' : _this$props$version;

      if (error) {
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls)
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-wrapper")
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-imgwrap")
        }, /*#__PURE__*/React.createElement("img", {
          className: "".concat(prefixCls, "-imgwrap-pic"),
          alt: "",
          src: image
        })), /*#__PURE__*/React.createElement("p", {
          className: "".concat(prefixCls, "-title")
        }, title), /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-tips")
        }, /*#__PURE__*/React.createElement("p", {
          className: "".concat(prefixCls, "-tips-text")
        }, "\u5F53\u524D\u5B9E\u9A8C\u5BA4\u9700\u8981\u5728win7\u53CA\u4EE5\u4E0A\u7CFB\u7EDF\u3001Mac OS\u7CFB\u7EDF\u4E2D\uFF0C\u4F7F\u7528", /*#__PURE__*/React.createElement("span", null, version), "\u7248\u672C\u4EE5\u4E0A\u7684\u8C37\u6B4Cchrome\u6D4F\u89C8\u5668\uFF08", /*#__PURE__*/React.createElement("a", {
          href: "https://www.google.cn/chrome/"
        }, "https://www.google.cn/chrome/"), "\uFF09\u3002 \u5982\u679C\u60A8\u7684\u7CFB\u7EDF\u7248\u672C\u6216\u6D4F\u89C8\u5668\u7248\u672C\u8FC7\u4F4E\uFF0C\u53EF\u80FD\u9020\u6210\u90E8\u5206\u63D2\u4EF6\u65E0\u6CD5\u6B63\u5E38\u52A0\u8F7D\uFF0C\u5BFC\u81F4\u9875\u9762\u6253\u5F00\u5931\u8D25\uFF0C\u8BF7\u624B\u52A8\u8FDB\u884C\u66F4\u6362\u6216\u5347\u7EA7\u3002"), /*#__PURE__*/React.createElement("p", {
          className: "".concat(prefixCls, "-tips-text")
        }, "\u5982\u679C\u5347\u7EA7\u7CFB\u7EDF\u548C\u6D4F\u89C8\u5668\u7248\u672C\u540E\uFF0C\u4ECD\u672A\u89E3\u51B3\u95EE\u9898\uFF0C\u6B22\u8FCE\u8054\u7CFB\u6263\u53EE\u5B98\u65B9\u5DE5\u4F5C\u4EBA\u5458\uFF1A", /*#__PURE__*/React.createElement("span", null, "coding@tencent.com"), "\u3002")), /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-detail")
        }, /*#__PURE__*/React.createElement("p", {
          className: "".concat(prefixCls, "-detail-name")
        }, error.toString()), /*#__PURE__*/React.createElement("p", {
          className: "".concat(prefixCls, "-detail-info")
        }, info.componentStack))));
      }

      return children;
    }
  }]);

  return ErrorBoundary;
}(Component);

export default ErrorBoundary;